export const ACTOR = {
  USER: 'USER',
  AGENT: 'AGENT',
  TEAM: 'TEAM',
} as const;
